export const OWNER = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 500 500";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};

	let iconColor = props.iconColor || "rgb(0,0,0)";


	let darklite = props.darklite || "lite";
	if(darklite === 'dark')
	{

		return(
			<div>
			<svg xmlns="http://www.w3.org/2000/svg"
				width={svgWidth}
				height={svgHeight}
				viewBox={svgViewBox}
				preserveAspectRatio={svgPreserveAspectRatio}
				style={svgStyle}
			>


				<path 
					fill={iconColor}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M467,340.315v131.329H33V340.315 c0-43.893,35.707-79.602,79.596-79.602l64.413-0.152c-32.991-23.091-54.608-61.372-54.608-104.608 c0-70.357,57.242-127.598,127.602-127.598c70.357,0,127.597,57.24,127.597,127.598c0,43.237-21.615,81.518-54.606,104.608 l64.487,0.152C431.292,260.714,467,296.423,467,340.315z M285.729,277.492l-19.381,23.571l24.975,30.371L250,390.903l-41.321-59.469	l24.969-30.371l-19.375-23.571H285.729L285.729,277.492z M387.4,277.714l-47.313-0.222l-90.097,129.665l-90.097-129.665 l-47.298,0.222C78.166,277.714,50,305.885,50,340.315v114.329c141.737,0,258.264,0,400,0V340.315 C450,305.885,421.832,277.714,387.4,277.714L387.4,277.714z M250.002,45.355c60.915,0,110.597,49.685,110.597,110.598	s-49.683,110.604-110.597,110.604c-60.916,0-110.602-49.69-110.602-110.604S189.086,45.355,250.002,45.355L250.002,45.355z M319.172,409.354v11.767h68.221v-11.767H319.172L319.172,409.354z M257.547,158.963c6.947,1.793,12.21,3.982,15.759,6.593 c3.595,2.591,5.378,6.257,5.378,10.996c0,4.405-1.855,8.291-5.509,11.614c-3.664,3.318-8.881,5.531-15.628,6.614V158.963 L257.547,158.963z M244.84,134.685c-6.024-1.795-10.461-3.814-13.401-6.008c-2.938-2.206-4.404-5.478-4.404-9.78 c0-4.513,1.563-7.934,4.716-10.155c3.119-2.233,7.493-4.02,13.089-5.39V134.685L244.84,134.685z M256.703,78.563	c0-4.471-2.13-6.699-6.396-6.699c-4.211,0-6.335,2.284-6.335,6.87v8.682c-13.796,0.979-24.365,4.469-31.673,10.463 c-7.323,5.972-10.97,13.684-10.97,23.06c0,7.208,1.873,13.092,5.597,17.682c3.73,4.575,8.618,8.089,14.635,10.578 c6.014,2.484,13.466,4.717,22.411,6.75v38.026c-4.47-1.039-8.053-2.54-10.754-4.493c-2.716-1.952-4.717-4.125-6.053-6.504 c-1.333-2.372-2.897-5.814-4.683-10.283c-0.815-2.058-2.248-3.641-4.354-4.798c-2.032-1.145-4.568-1.72-7.574-1.72 c-3.753,0-6.874,1.054-9.369,3.145c-2.527,2.103-3.758,4.442-3.758,7.069c0,3.541,0.926,7.177,2.803,10.827 c1.849,3.685,4.747,7.23,8.662,10.64c3.897,3.406,8.771,6.248,14.617,8.54c5.839,2.295,12.639,3.803,20.464,4.494v22.085	c0,2.507,0.481,4.385,1.445,5.575c0.983,1.207,2.674,1.786,5.061,1.786c2.619,0,4.309-0.722,5.05-2.192	c0.794-1.489,1.175-3.819,1.175-7.03v-20.385c9.524-0.639,17.799-2.684,24.732-6.113c6.933-3.431,12.199-7.867,15.75-13.316	c3.603-5.419,5.374-11.232,5.374-17.459c0-4.971-1.132-9.518-3.356-13.705c-2.251-4.164-5.434-7.751-9.564-10.743 c-3.864-2.896-8.269-5.117-13.157-6.622c-4.918-1.537-11.518-3.238-19.778-5.076v-34.033c8.399,2.229,13.693,6.759,15.915,13.569 c1.914,5.775,6.145,8.682,12.715,8.682c3.479,0,6.422-1.014,8.853-2.983c2.468-1.991,3.658-4.357,3.658-7.067 c0-2.459-0.824-5.164-2.459-8.101c-1.615-2.95-3.932-5.803-6.945-8.593c-3.81-3.666-8.265-6.367-13.364-8.188 c-5.128-1.783-11.23-2.985-18.372-3.596V78.563L256.703,78.563z"
				/>

			</svg>
			</div>

		);//return


	}
	else // lite
	{


		return(
			<div>
			<svg xmlns="http://www.w3.org/2000/svg"
				width={svgWidth}
				height={svgHeight}
				viewBox={svgViewBox}
				preserveAspectRatio={svgPreserveAspectRatio}
				style={svgStyle}
			>
	
	
				<path 
					fill={iconColor}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M285.219,277.1h-70.436l19.099,23.234l-24.612,29.938L250,388.891l40.732-58.619 l-24.617-29.938L285.219,277.1L285.219,277.1z M385.438,277.318c33.939,0,61.705,27.768,61.705,61.707v112.695	c-139.711,0-254.573,0-394.285,0V339.025c0-33.939,27.763-61.707,61.702-61.707l46.623-0.219l88.809,127.813l88.81-127.813 L385.438,277.318L385.438,277.318z M250.002,48.279c-60.046,0-109.021,48.975-109.021,109.018S189.957,266.32,250.002,266.32	c60.044,0,109.017-48.98,109.017-109.023S310.047,48.279,250.002,48.279L250.002,48.279z M318.184,407.078h67.246v11.598h-67.246
					V407.078L318.184,407.078z M257.439,160.264v35.306c6.65-1.067,11.793-3.249,15.404-6.52c3.602-3.276,5.43-7.106,5.43-11.448 c0-4.672-1.758-8.285-5.301-10.84C269.475,164.189,264.287,162.031,257.439,160.264L257.439,160.264z M244.914,136.332v-30.886	c-5.516,1.351-9.828,3.111-12.902,5.313c-3.108,2.189-4.648,5.562-4.648,10.01c0,4.241,1.444,7.466,4.341,9.641	C234.602,132.572,238.975,134.563,244.914,136.332L244.914,136.332z M256.607,81.012v8.695c7.039,0.602,13.055,1.787,18.109,3.544 c5.027,1.796,9.418,4.458,13.174,8.072c2.971,2.75,5.254,5.562,6.846,8.47c1.611,2.895,2.424,5.561,2.424,7.984 c0,2.672-1.174,5.004-3.605,6.967c-2.396,1.941-5.297,2.94-8.727,2.94c-6.477,0-10.646-2.864-12.533-8.558
					c-2.189-6.713-7.408-11.178-15.688-13.375v33.547c8.143,1.812,14.648,3.488,19.496,5.004c4.818,1.483,9.16,3.672,12.969,6.527 c4.072,2.949,7.209,6.485,9.428,10.59c2.193,4.127,3.309,8.609,3.309,13.509c0,6.138-1.746,11.868-5.297,17.21 c-3.5,5.371-8.691,9.744-15.525,13.126c-6.834,3.381-14.99,5.396-24.379,6.026v20.093c0,3.165-0.375,5.462-1.158,6.93 c-0.73,1.45-2.396,2.161-4.978,2.161c-2.353,0-4.02-0.57-4.989-1.76c-0.95-1.174-1.425-3.025-1.425-5.496v-21.77	c-7.713-0.682-14.416-2.168-20.172-4.43c-5.762-2.26-10.566-5.061-14.408-8.418c-3.859-3.36-6.715-6.855-8.538-10.487 c-1.85-3.599-2.763-7.183-2.763-10.673c0-2.59,1.213-4.896,3.704-6.969c2.46-2.061,5.536-3.1,9.235-3.1 c2.962,0,5.462,0.567,7.466,1.695c2.077,1.141,3.489,2.701,4.292,4.729c1.76,4.405,3.302,7.798,4.616,10.137 c1.317,2.345,3.29,4.486,5.967,6.41c2.663,1.926,6.194,3.405,10.601,4.43v-37.483c-8.816-2.004-16.163-4.205-22.09-6.653	c-5.931-2.454-10.75-5.917-14.426-10.427c-3.67-4.524-5.517-10.324-5.517-17.43c0-9.242,3.594-16.844,10.813-22.729	c7.204-5.909,17.621-9.35,31.22-10.313v-8.558c0-4.521,2.093-6.772,6.245-6.772C254.508,74.408,256.607,76.605,256.607,81.012 L256.607,81.012z"
				/>
	
	
	   
	
			</svg>
			</div>
	
		);//return

		
	}

	
}